import { format } from 'date-fns';

export const fmtPKR = (n: number): string =>
  'Rs ' + Math.round(n ?? 0).toLocaleString('en-PK');

export const formatCurrency = fmtPKR;

export const fmtDate = (d: string | Date): string =>
  format(new Date(d), 'dd MMM yyyy');

export const formatDate = fmtDate;

export const fmtDateTime = (d: string | Date): string =>
  format(new Date(d), 'dd MMM yyyy, hh:mm a');

export const QUOTE_STATUS_LABELS: Record<string, string> = {
  draft: 'Draft', sent: 'Sent', approved: 'Approved', rejected: 'Rejected', expired: 'Expired'
};

// Trailing slash hatake double-slash bug se bachao
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');

export const getImageUrl = (url: string | null | undefined): string => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API_URL}${url}`;
};

// Extracts a human-friendly error message from an axios/unknown error
export const apiError = (e: unknown, fallback = 'Something went wrong'): string => {
  const err = e as { response?: { data?: { message?: string } }; message?: string };
  return err?.response?.data?.message || err?.message || fallback;
};